/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DataModel } from './data-model';
import { ModelProperty } from './model-property';
import { Entity } from '../model/entity/entity';
import { Validation } from './validation/validation';
import { PropertyGroup } from './property-group';
import { ActionGenerator } from '../tool/action/action-generator';
import { StandardActionBuilder } from '../builder/action/standard-action-builder';

export class DataModelConverter {
  /**
   * Convert http response schema to DataModel Object
   * @param model
   * @param entity
   */
  convert(model: any, entity?: Entity): DataModel {
    const dataModel = new DataModel(entity);
    dataModel.id = model.id;
    dataModel.title = model.title;
    dataModel.type = model.type;
    dataModel.required = model.required ? model.required : [];
    this.createFormGroup(model, dataModel);
    this.createProperties(model, dataModel);
    return dataModel;
  }

  private createProperties(model: any, dataModel: DataModel) {
    for (const attr in model.properties) {
      const property = model.properties[attr];
      if (property.noGen) {
        continue;
      }
      const dataModelProperty = new ModelProperty(
        attr,
        property.title,
        property.type,
      );
      for (const propertyName in property) {
        switch (propertyName) {
          case 'validation':
            dataModelProperty.validation = new Validation(property.validation);
            continue;

          case 'formActions':
            dataModelProperty.formActions = property.formActions.map(
              (action) => {
                return new StandardActionBuilder(
                  action.name ?? '',
                  action.icon ?? '',
                )
                  .setEnable(action.enable ?? true)
                  .setIconColor(action.iconColor ?? '')
                  .setTextColor(action.textColor ?? '')
                  .setNoticeBadge(action.noticeBadge ?? '')
                  .setShowText(action.text ? true : false)
                  .setTooltip(action.tooltip ?? '')
                  .build();
              },
            );
            break;

          default:
            dataModelProperty[propertyName] = property[propertyName];
            dataModelProperty.mainLabel =
              property.mainLabel || property.mainLib;
            break;
        }
      }
      dataModelProperty.init();
      dataModel.addProperty(dataModelProperty);
    }
  }

  private createFormGroup(model: any, dataModel: DataModel) {
    if (model.formGroups) {
      dataModel.formGroups = [];
      for (const group of model.formGroups) {
        const formGroup = new PropertyGroup(group.id, group.title, group.icon);
        formGroup.column = group.column;
        formGroup.actions = group.actions.map((action) =>
          new ActionGenerator().generateAction(action),
        );
        dataModel.formGroups.push(formGroup);
      }
    } else {
      dataModel.formGroups = [];
    }
  }
}
